(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kx-academy-home"] && !Shopify.designMode) return;
  try {
    
const root=document.querySelector('[data-kxv2]');if(root){const items=root.querySelectorAll('[data-reveal]');if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{threshold:.12});items.forEach(item=>observer.observe(item))}else{items.forEach(item=>item.classList.add('is-visible'))}}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    function filterFromHash() {
      if (window.location.hash === '#upcoming-cohorts') return 'upcoming';
      if (window.location.hash === '#available-courses') return 'available';
      if (window.location.hash === '#all-courses') return 'all';
      return 'all';
    }

    document.documentElement.setAttribute('data-kx-course-filter-start', filterFromHash());

    function applyCourseFilter(wrap, filter) {
      const buttons = wrap.querySelectorAll('[data-kx-course-filter]');
      const cards = wrap.querySelectorAll('[data-kx-course-status]');
      const empty = wrap.querySelector('[data-kx-empty-message]');
      let visibleCount = 0;

      cards.forEach(function (card) {
        const status = card.getAttribute('data-kx-course-status');
        const show = filter === 'all' || status === filter;
        card.hidden = !show;
        card.classList.toggle('is-hidden', !show);
        if (show) visibleCount += 1;
      });

      buttons.forEach(function (button) {
        const active = button.getAttribute('data-kx-course-filter') === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (empty) {
        empty.hidden = visibleCount !== 0;
      }

      document.documentElement.setAttribute('data-kx-course-filter-start', filter);
    }

    function scrollToCourses() {
      const target = document.getElementById('kambaxenia-course-filter') || document.getElementById('all-courses');
      if (target && window.location.hash) {
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 40);
      }
    }

    function syncFromHash() {
      const filter = filterFromHash();
      document.querySelectorAll('[data-kx-course-filter-wrap]').forEach(function (wrap) {
        applyCourseFilter(wrap, filter);
      });
      scrollToCourses();
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-kx-course-filter-wrap]').forEach(function (wrap) {
        const buttons = wrap.querySelectorAll('[data-kx-course-filter]');

        buttons.forEach(function (button) {
          button.addEventListener('click', function (event) {
            event.preventDefault();

            const filter = button.getAttribute('data-kx-course-filter');
            const hash = filter === 'upcoming' ? '#upcoming-cohorts' : filter === 'available' ? '#available-courses' : '#all-courses';

            if (window.location.hash === hash) {
              syncFromHash();
            } else {
              window.location.hash = hash;
            }
          });
        });
      });

      syncFromHash();
    });

    window.addEventListener('hashchange', syncFromHash);
    document.addEventListener('shopify:section:load', syncFromHash);
  })();

  } catch(e) { console.error(e); }
})();
})();
